var chunkMapping = {
	"348": [
		3852,
		5613
	]
};
var idToExternalAndNameMapping = {
	"3852": [
		"default",
		".",
		388
	],
	"5613": [
		"default",
		".",
		9467
	]
};
var idToRemoteMap = {
	"3852": [
		{
			"externalType": "script",
			"name": "shipbob_mfe_runtime"
		}
	],
	"5613": [
		{
			"externalType": "script",
			"name": "shipbob_design_system"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"3852": {
		"shareScope": "default",
		"name": ".",
		"externalModuleId": 388,
		"remoteName": "shipbob_mfe_runtime"
	},
	"5613": {
		"shareScope": "default",
		"name": ".",
		"externalModuleId": 9467,
		"remoteName": "shipbob_design_system"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}